import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { TextFieldComponent } from './text-field.component';

@Component({
  selector: 'app-autosize-text-field',
  templateUrl: './autosize-text-field.component.html',
  styleUrls: ['./autosize-text-field.component.scss']
})
export class AutosizeTextFieldComponent extends TextFieldComponent implements OnInit, AfterViewInit {

  @Input() returnEnabled: boolean = true;

  ngOnInit() {
    super.ngOnInit();
    this.control.valueChanges.debounceTime(600).subscribe(
      (value) => this.resizeToFit()
    )
    Observable.fromEvent(window, 'resize').debounceTime(1200).subscribe(
      () => this.resizeToFit()
    )
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => this.resizeToFit(), 500);
  }

  updateLinkedFields() {
    super.updateLinkedFields();
    setTimeout(() => this.resizeToFit(), 100);
  }

  resizeToFit() {
    if (this.input != null) {
      let textarea = this.input.nativeElement;
      textarea.style.height = 'auto';
      textarea.style.overflow = 'hidden';
      textarea.style.height = textarea.scrollHeight + 'px';
      textarea.style.overflow = '';
    }
    this.resized.emit(this);
  }

  setValue(value: any, emit?: boolean) {
    super.setValue(value, emit);
    this.resizeToFit();
  }

  onBlur(event) {
    super.onBlur(event);
    this.resizeToFit();
    return true;
  }

  onReturnKey() {
    if (this.returnEnabled) {
      return true;
    } else {
      this.blur();
      this.returnKey.emit(this);
      return false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/autosize-text-field.component.ts